import * as React from 'react';

/**
 * @description Earth icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Earth } from '@sravni/design-system-icons'
 *
 * <Earth />
 * ```
 */
const Earth = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "Earth", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("g", { clipPath: "url(#Earth__a)" },
        React.createElement("g", { clipPath: "url(#Earth__b)", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("path", { d: "M2.5 10h3.477a2.357 2.357 0 0 0 1.666-4.023L5.598 3.93M15.243 15.365l-1.48-2.22a1.445 1.445 0 0 0-1.203-.645c-.548 0-1.048-.31-1.293-.8l-.11-.22a1.446 1.446 0 0 1 0-1.293l.944-1.889c.244-.489.745-.798 1.292-.798h3.673" }),
            React.createElement("path", { d: "M10 2.5c4.152 0 7.5 3.348 7.5 7.5s-3.348 7.5-7.5 7.5M10 17.5A7.488 7.488 0 0 1 2.5 10c0-4.152 3.348-7.5 7.5-7.5" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "Earth__a" },
            React.createElement("path", { fill: "currentColor", d: "M0 0h20v20H0z" })),
        React.createElement("clipPath", { id: "Earth__b" },
            React.createElement("path", { fill: "currentColor", d: "M0 0h20v20H0z" }))))));

export { Earth };
//# sourceMappingURL=Earth.js.map
